// FIXME: Ideally this should be based on the organization country settings
export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const getAmountDisplay = (amount: number, showDollarSign = true) => {
  return formatter.format(amount);
};

export const round = (value: number, decimals = 2) => {
  return Number(Math.round(`${value}e${decimals}` as any) + `e-${decimals}`);
};
